export class PartSupplierPruBe {
    public constructor(public id:number) { this.Id = id; }
    Id: number;
    PartId: number; 
    PartNo: string;
    PartDescription: string;
    PartShortDescription: string;
    SupplierId: number; 
    SupplierNo: string;
    SupplierName: string;
    PruId: number; 
    Active: boolean
    PruMCName: string;
    PruMCCodeName: string;
    PruName: string;
    Selected: boolean = false;
    Weight: number;
    WeightCode: string;
    IsSparePart: boolean;
    countofemailExists: number;
}


export class PartListBE
{
    Id: number;
    PartNo :  string ;
    Description: string;
    PartStatus: string;
    IsMultiPart: boolean;
    Quantity: number;
    HavePartRelations: boolean = false;
}


// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/app/partsupplierpru/shared/partsupplierpru.model.ts